import { useState } from 'react'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'

import AddRoleModal from './AddRoleModal'

export interface AddRoleProps {
  disabledEmployeeIds: number[]
  onCreateRow: (owners: number[], editors: number[]) => void
  buttonCentered?: boolean
}

const AddRole = ({ disabledEmployeeIds, onCreateRow, buttonCentered }: AddRoleProps) => {
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeForSelectFragmentNoAccess[]>(
    []
  )

  const disableSubmitButton = () => {
    return !selectedEmployees.length
  }

  const onClose = () => {
    setSelectedEmployees([])
  }

  const onSubmit = () => {
    onCreateRow(
      [],
      selectedEmployees.map((employee) => employee.id)
    )
    setSelectedEmployees([])
  }

  const onSelectEmployees = (newEmployees: EmployeeForSelectFragmentNoAccess[]) => {
    setSelectedEmployees(newEmployees)
  }

  return (
    <AddRoleModal
      onClose={onClose}
      onSubmit={onSubmit}
      disableSubmitButton={disableSubmitButton}
      disabledEmployeeIds={disabledEmployeeIds}
      onSelectEmployees={onSelectEmployees}
      selectedEmployees={selectedEmployees}
      buttonCentered={buttonCentered}
    />
  )
}

export default AddRole
